module.exports = __webpack_public_path__ + "static/media/ICT-2.b4143228.jpg";